import reducer from "./reducers";

export { default as ContentSelectors } from "./selectors";
export { default as ContentActions } from "./actions";
//export { default as ContentTypes } from "./types";

export default reducer;



// WEBPACK FOOTER //
// ./dev/ducks/content/index.js